// extracted by mini-css-extract-plugin
export default {"container":"TasksContainer_container__pH6Q2","dark":"TasksContainer_dark__hrtwl"};